// Mock data for EEDOC website
import url from "./lib/url";

export const mockData = {
  hero: {
    title: "EEDOC",
    subtitle: "Sua Solução Completa para Gestão Fiscal e Financeira",
    description:
      "Emissão de documentos fiscais, gestão financeira e automação para pequenas e médias empresas. Mais de 30 anos de experiência em tecnologia.",
    ctas: [
      { text: "Experimentar Grátis", type: "primary", link: "#planos" },
      {
        text: "Acessar Sistema",
        type: "secondary",
        link: `${url}`,
      },
      { text: "Falar com Vendas", type: "outline", link: "#contato" },
    ],
  },

  about: {
    title: "Sobre a EEDOC",
    description:
      "A EEDOC é uma plataforma SaaS completa para emissão, gestão e automação de documentos fiscais eletrônicos. Com origem em um grupo empresarial com mais de 30 anos de atuação no mercado de tecnologia e forte experiência em soluções corporativas, a EEDOC nasce com base sólida, maturidade técnica e suporte altamente especializado.",
    highlights: [
      { value: "30+", label: "Anos de Experiência" },
      { value: "100%", label: "Conformidade Fiscal" },
      { value: "24/7", label: "Suporte Especializado" },
      { value: "Ilimitado", label: "Emissões (planos pagos)" },
    ],
  },

  features: {
    title: "Funcionalidades Completas",
    subtitle: "Tudo que sua empresa precisa em uma única plataforma",
    categories: [
      {
        name: "Emissão de Documentos Fiscais",
        items: [
          {
            icon: "FileText",
            title: "NF-e",
            description: "Nota Fiscal Eletrônica com validação automática",
          },
          {
            icon: "Receipt",
            title: "NFC-e",
            description: "Nota Fiscal do Consumidor Eletrônica",
          },
          {
            icon: "FileCheck",
            title: "NFS-e",
            description:
              "Nota Fiscal de Serviço Eletrônica (padrão nacional e municipal)",
          },
          {
            icon: "Truck",
            title: "DF-e",
            description: "CT-e, MDF-e e eventos",
          },
          {
            icon: "CheckCircle",
            title: "Manifestação",
            description: "Manifestação de Destinatário automática",
          },
        ],
      },
      {
        name: "Gestão Financeira",
        items: [
          {
            icon: "DollarSign",
            title: "Fluxo de Caixa",
            description: "Controle completo e projetado",
          },
          {
            icon: "CreditCard",
            title: "Contas a Pagar/Receber",
            description: "Gestão integrada de cobranças",
          },
          {
            icon: "TrendingUp",
            title: "Conciliação Bancária",
            description: "Integração com bancos",
          },
          {
            icon: "Bell",
            title: "Cobrança Automática",
            description: "Lembretes e boletos automáticos",
          },
        ],
      },
      {
        name: "Relatórios e Análises",
        items: [
          {
            icon: "BarChart3",
            title: "Dashboards",
            description: "Visualização interativa de dados",
          },
          {
            icon: "FileBarChart",
            title: "Relatórios Personalizados",
            description: "Crie relatórios sob medida",
          },
          { icon: "Download", title: "Exportação", description: "PDF e Excel" },
        ],
      },
    ],
  },

  pricing: {
    title: "Planos que Cabem no Seu Bolso",
    subtitle: "Escolha o plano ideal para o seu negócio",
    plans: [
      {
        name: "Gratuito",
        price: "R$ 0",
        period: "/mês",
        description: "Ideal para começar",
        features: [
          "5 NF-e por mês",
          "5 NFC-e por mês",
          "Suporte por e-mail",
          "Armazenamento de XML",
        ],
        limitations: ["Sem controle financeiro", "Sem relatórios avançados"],
        cta: "Começar Grátis",
        popular: false,
      },
      {
        name: "Emissor",
        price: "R$ 30",
        period: "/mês",
        description: "Para quem emite documentos",
        features: [
          "Emissões ilimitadas",
          "NF-e, NFC-e, NFS-e",
          "Manifestação eletrônica",
          "Download de XML",
          "Suporte prioritário",
        ],
        limitations: ["Sem módulo financeiro"],
        cta: "Assinar Agora",
        popular: false,
      },
      {
        name: "Gestor",
        price: "R$ 90",
        period: "/mês",
        description: "Solução completa",
        features: [
          "Tudo do Emissor +",
          "Gestão Financeira Completa",
          "Fluxo de Caixa",
          "Contas a Pagar/Receber",
          "Cobrança Automática",
          "Relatórios Avançados",
          "Suporte Exclusivo",
          "Pronto para Reforma Tributária",
        ],
        limitations: [],
        cta: "Plano Completo",
        popular: true,
      },
    ],
  },

  differentials: {
    title: "Por Que Escolher a EEDOC?",
    items: [
      {
        icon: "Award",
        title: "30+ Anos de Experiência",
        description: "Expertise consolidada em soluções corporativas e fiscais",
      },
      {
        icon: "Shield",
        title: "Segurança Garantida",
        description: "Dados protegidos com criptografia de ponta a ponta",
      },
      {
        icon: "Cloud",
        title: "Infraestrutura em Nuvem",
        description: "Acesse de qualquer lugar, a qualquer momento",
      },
      {
        icon: "Scale",
        title: "Conformidade Legal",
        description: "Sempre atualizado com a legislação fiscal",
      },
      {
        icon: "Headphones",
        title: "Suporte Especializado",
        description: "Time experiente pronto para ajudar",
      },
      {
        icon: "Workflow",
        title: "Automação Inteligente",
        description: "Reduza erros e retrabalho",
      },
    ],
  },

  targetAudience: {
    title: "Para Quem é a EEDOC?",
    subtitle: "Desenvolvida especialmente para pequenas e médias empresas",
    audiences: [
      {
        icon: "Store",
        title: "Comércio",
        description: "Lojas físicas e online que precisam emitir NF-e e NFC-e",
      },
      {
        icon: "Factory",
        title: "Indústria",
        description: "Controle completo de entrada, saída e gestão fiscal",
      },
      {
        icon: "Briefcase",
        title: "Prestadores de Serviço",
        description: "Emissão de NFS-e e gestão financeira",
      },
      {
        icon: "Calculator",
        title: "Escritórios Contábeis",
        description: "Centralize operações de múltiplos clientes",
      },
      {
        icon: "Code",
        title: "Desenvolvedores",
        description: "Integre emissões fiscais via API",
      },
      {
        icon: "Building2",
        title: "Empresas de Todos os Portes",
        description: "Solução escalável que cresce com seu negócio",
      },
    ],
  },

  testimonials: {
    title: "O Que Nossos Clientes Dizem",
    subtitle: "Depoimentos de empresas que confiam na EEDOC",
    items: [
      {
        name: "João Silva",
        company: "Silva & Associados Contabilidade",
        text: "A EEDOC transformou nossa operação fiscal. Antes gastávamos horas emitindo notas manualmente, agora tudo é automático e muito mais rápido. O suporte é excepcional!",
      },
      {
        name: "Maria Santos",
        company: "Comercial Santos Ltda",
        text: "Como pequena empresa, precisávamos de uma solução acessível e completa. O plano Gestor da EEDOC nos deu tudo que precisamos para gerenciar nossa operação fiscal e financeira.",
      },
      {
        name: "Pedro Oliveira",
        company: "Indústria Oliveira",
        text: "A preparação para a Reforma Tributária estava nos preocupando muito. Com a EEDOC, ficamos tranquilos sabendo que estamos sempre em conformidade com a legislação.",
      },
      {
        name: "Ana Costa",
        company: "Costa Serviços",
        text: "O melhor investimento que fizemos! A emissão de NFS-e ficou muito mais simples, e o controle financeiro integrado nos ajudou a ter uma visão completa do negócio.",
      },
      {
        name: "Carlos Ferreira",
        company: "Ferreira Comércio",
        text: "Migrei de outro sistema e a diferença é enorme. A EEDOC é muito mais intuitiva, rápida e o suporte resolve qualquer dúvida rapidamente.",
      },
      {
        name: "Juliana Almeida",
        company: "Almeida Distribuidora",
        text: "Excelente plataforma! Conseguimos reduzir erros em 90% e o tempo de emissão de notas caiu pela metade. Recomendo para qualquer empresa.",
      },
    ],
  },

  faq: {
    title: "Perguntas Frequentes",
    questions: [
      {
        question: "Como funciona o plano gratuito?",
        answer:
          "O plano gratuito permite a emissão de até 5 NF-e e 5 NFC-e por mês, com suporte por e-mail e armazenamento de XML. É ideal para testar a plataforma antes de assinar um plano pago.",
      },
      {
        question: "Posso mudar de plano a qualquer momento?",
        answer:
          "Sim! Você pode fazer upgrade ou downgrade do seu plano a qualquer momento. As mudanças são aplicadas imediatamente e o valor é ajustado proporcionalmente.",
      },
      {
        question: "A EEDOC está preparada para a Reforma Tributária?",
        answer:
          "Sim! A plataforma já está totalmente preparada para as mudanças trazidas pela Reforma Tributária, garantindo que sua empresa esteja em conformidade.",
      },
      {
        question: "Como funciona o armazenamento de XML?",
        answer:
          "Todos os XMLs dos documentos fiscais são armazenados de forma segura em nossa nuvem, com backup automático. Você pode consultar e baixar os arquivos a qualquer momento.",
      },
      {
        question: "Qual o suporte oferecido?",
        answer:
          "Oferecemos suporte por e-mail no plano gratuito, suporte prioritário no plano Emissor, e suporte exclusivo com atendimento especializado no plano Gestor.",
      },
      {
        question: "Meus dados estão seguros?",
        answer:
          "Absolutamente! Utilizamos infraestrutura em nuvem com alta disponibilidade, backup automático e criptografia de ponta a ponta para garantir a segurança dos seus dados.",
      },
    ],
  },

  footer: {
    company: {
      name: "EEDOC",
      description:
        "Plataforma completa para emissão e gestão de documentos fiscais eletrônicos.",
      tagline: "Mais de 30 anos de experiência em tecnologia",
    },
    links: {
      product: [
        { label: "Funcionalidades", href: "#funcionalidades" },
        { label: "Planos e Preços", href: "#planos" },
        { label: "Depoimentos", href: "#depoimentos" },
      ],
      company: [
        { label: "Sobre Nós", href: "#sobre" },
        { label: "Contato", href: "#contato" },
        { label: "Suporte", href: "#suporte" },
      ],
      legal: [
        { label: "Termos de Uso", href: "#termos" },
        { label: "Política de Privacidade", href: "#privacidade" },
      ],
    },
    contact: {
      phone: "(15) 99108-9431",
      email: "eedoc@gatewaysistemas.com.br",
      location: "Itapetininga, São Paulo",
      portal: `${url}`,
    },
  },
};
